import React from 'react'
import styled from '@emotion/styled'
import { colors, font } from '@mobi/component-library/Theme/Common'
import type { BetLoopProfile } from '@core/Areas/BetLoop/types'

const enum LocalConstants {
  TruncatedTextLength = 160,
}

export const ProfileBio: React.FC<Pick<BetLoopProfile, 'description'>> = ({ description }) => {
  const [isFullBioShown, setIsFullBioShown] = React.useState(false)

  const profileBio = description ?? ''

  if (!profileBio) return null

  const shouldEnableBioTruncateToggle = profileBio.length > LocalConstants.TruncatedTextLength
  const profileBioDisplayText =
    !isFullBioShown && shouldEnableBioTruncateToggle
      ? `${profileBio.slice(0, LocalConstants.TruncatedTextLength).trim()}…`
      : profileBio

  return (
    <ParagraphStyled data-testid='ProfileBio'>
      {profileBioDisplayText}{' '}
      {shouldEnableBioTruncateToggle ? (
        <button type='button' onClick={() => setIsFullBioShown(prev => !prev)}>
          {isFullBioShown ? 'Show Less' : 'Read More'}
        </button>
      ) : null}
    </ParagraphStyled>
  )
}

// ======
// Styles
// ======

const ParagraphStyled = styled.p({
  fontFamily: font.family.primary,
  fontSize: font.size.md.fontSize,
  letterSpacing: font.size.md.letterSpacing,
  lineHeight: font.size.md.lineHeight,
  fontWeight: font.weight.regular,
  color: colors.neutral[700],
  wordBreak: 'break-word',
  whiteSpace: 'pre-line',
  margin: '0 auto',
  width: 'fit-content',

  '> button': {
    fontSize: 'inherit',
    fontWeight: font.weight.semibold,
    color: colors.neutral[800],
    cursor: 'pointer',
    textDecoration: 'underline',
    whiteSpace: 'nowrap',
    padding: 0,
    background: 0,
    border: 0,
  },
})
